import { AuthUser } from './userService';

// Mock user data for development
const mockUsers: AuthUser[] = [
  {
    uid: 'user1',
    email: 'john.doe@example.com',
    displayName: 'John Doe',
    lastSignInTime: new Date().toISOString(),
    creationTime: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days ago
    disabled: false,
    emailVerified: true,
    phoneNumber: '+1234567890'
  },
  {
    uid: 'user2',
    email: 'jane.smith@example.com',
    displayName: 'Jane Smith',
    lastSignInTime: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago
    creationTime: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(), // 60 days ago
    disabled: false,
    emailVerified: true,
    phoneNumber: '+0987654321'
  },
  {
    uid: 'user3',
    email: 'mark.wilson@example.com',
    displayName: 'Mark Wilson',
    lastSignInTime: undefined,
    creationTime: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(), // 10 days ago
    disabled: true,
    emailVerified: false,
    phoneNumber: undefined
  },
  {
    uid: 'user4',
    email: 'sarah.johnson@example.com',
    displayName: 'Sarah Johnson',
    lastSignInTime: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), // 1 day ago
    creationTime: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(), // 45 days ago
    disabled: false,
    emailVerified: true,
    phoneNumber: '+1122334455'
  },
  {
    uid: 'user5',
    email: 'david.brown@example.com',
    displayName: undefined,
    lastSignInTime: undefined,
    creationTime: new Date().toISOString(), // today
    disabled: false,
    emailVerified: false,
    phoneNumber: undefined
  }
];

// Simulates fetching users from Firebase Authentication
export const fetchMockUsers = async (pageToken?: string): Promise<{ users: AuthUser[], pageToken?: string }> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // Number of users per page
  const pageSize = 3;
  
  // Convert pageToken to index
  const startIndex = pageToken ? parseInt(pageToken) : 0;
  
  // Get subset of users for this page
  const paginatedUsers = mockUsers.slice(startIndex, startIndex + pageSize);
  
  // Calculate next page token
  const nextPageToken = 
    startIndex + pageSize < mockUsers.length 
      ? (startIndex + pageSize).toString() 
      : undefined;
  
  return {
    users: paginatedUsers,
    pageToken: nextPageToken
  };
};

// Simulates searching users by email
export const searchMockUsersByEmail = async (email: string): Promise<AuthUser[]> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // Filter users by email
  return mockUsers.filter(user => 
    user.email && user.email.toLowerCase().includes(email.toLowerCase())
  );
};
